
export interface ReportConfig {
  url: any,
  formData: any | Function,
  fileName: Function | string,
  fileTypes?: _DOWNLOAD_TYPE[];
  baseUrl?: any,
  exportIcon?: boolean,
}

export interface _DOWNLOAD_TYPE { name: string, value: string };

export const DOWNLOAD_TYPE: _DOWNLOAD_TYPE[] = [
  { name: 'XLSX', value: '.xlsx' },
  { name: 'XLS', value: '.xls' },
  { name: 'CSV', value: '.csv' },
];


export const pytCustTblDefConfig: pytCustTblInterface = {
  showSort: false,
  downloadReports: null,
  reloadTable: true,
  rotateIt: true,
  searchType: 'server',
  serverSearchVal: '',
  localFilterVal: '',
  sortBy: '',
  sortDirection: 'desc',
  itmeLengthStartFrom: 0,
  totalCount: 0,
  currentPage: 1,
  totalPages: 0,
  totalItmePerPage: 100,
  pagger: ['All', 10, 50, 100, 200, 500],
  fromRec: 0,
  toRec: 0,
  placeholder: 'Search by Mobile No. or Transaction ID',
  addButton: false,
  showSearch: true,
  showRecordDropdown: true,
  showToggel: false,
  toggValue: false,
};

export interface pytCustTblInterface {
  showSort: boolean;
  downloadReports: ReportConfig | null;
  reloadTable: boolean;
  rotateIt: boolean;
  searchType?: 'local' | 'server' | null;
  serverSearchVal: string;
  localFilterVal: string;
  sortBy: string;
  sortDirection: 'asc' | 'desc';
  itmeLengthStartFrom: number;
  totalCount: number;
  currentPage: number;
  totalPages: number | any;
  totalItmePerPage: number | any;
  pagger: (string | number)[];
  fromRec: number;
  toRec: number;
  placeholder: string;
  addButton: boolean;
  showSearch: boolean;
  showRecordDropdown: boolean;
  showToggel: boolean,
  toggValue: boolean;
}



export class pytCustTblCnfg {
  public initValue!: pytCustTblInterface;
  constructor(private keys: Partial<pytCustTblInterface> = {}
  ) {

    this.initValue = {
      ...pytCustTblDefConfig,
      ...keys
    } as pytCustTblInterface
  }

}

export class EmployeeClass {
  constructor(
    private id: number = 0,
    private firstName: string,
    private lastName?: string,
    private salary?: number
  ) { }

  getName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  getYearlySalary(): any {
    if (this.salary) {
      return 12 * this.salary;
    }
    return null;
  }
}
export interface EmployeeClassInter {
  firstName: string;
  id?: number;
  lastName?: string;
  salary?: number;
}
export class EmployeeClass1 implements EmployeeClassInter {
  constructor(public firstName: string, public id?: number) {
    // if (id) {
    //   this.id = id;
    // }
  }
}